/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Playlist } from './Playlist';
import {
    PlaylistFromJSON,
    PlaylistFromJSONTyped,
    PlaylistToJSON,
} from './Playlist';

/**
 * 
 * @export
 * @interface PlaylistSearchResult
 */
export interface PlaylistSearchResult {
    /**
     * 
     * @type {Array<Playlist>}
     * @memberof PlaylistSearchResult
     */
    data?: Array<Playlist>;
}

/**
 * Check if a given object implements the PlaylistSearchResult interface.
 */
export function instanceOfPlaylistSearchResult(value: object): value is PlaylistSearchResult {
    let isInstance = true;

    return isInstance;
}

export function PlaylistSearchResultFromJSON(json: any): PlaylistSearchResult {
    return PlaylistSearchResultFromJSONTyped(json, false);
}

export function PlaylistSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaylistSearchResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(PlaylistFromJSON)),
    };
}

export function PlaylistSearchResultToJSON(value?: PlaylistSearchResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(PlaylistToJSON)),
    };
}

